import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const PostCard = ({ post, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`post-card-${post.slug}`}
    className="group"
  >
    <Link to="/resources" className="block">
      <div className="relative aspect-[16/10] overflow-hidden rounded-2xl bg-[#14306B]">
        <img src={post.image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
        <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 font-mono text-xs font-semibold text-slate-900 backdrop-blur">{post.category}</span>
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <h3 className="font-display text-xl font-semibold leading-snug tracking-tight text-slate-900 transition-colors duration-300 group-hover:text-[#1777AF]">{post.title}</h3>
        <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-slate-400 transition-[transform,color] duration-500 group-hover:rotate-45 group-hover:text-[#1777AF]" />
      </div>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
      <p className="mt-3 font-mono text-xs text-slate-500">{post.read} read</p>
    </Link>
  </motion.article>
);
